import { render, staticRenderFns } from "./show-most-toilet-staff.vue?vue&type=template&id=0bf9824d&"
import script from "./show-most-toilet-staff.vue?vue&type=script&lang=js&"
export * from "./show-most-toilet-staff.vue?vue&type=script&lang=js&"
import style0 from "./show-most-toilet-staff.vue?vue&type=style&index=0&id=0bf9824d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports